import React, {
	useEffect,
	useState
} from "react";

import styled from "styled-components";

import {
	doc,
	getDoc,
	setDoc
} from "firebase/firestore";

import { db } from "../firebase/firebaseConfig";

import { useAuth } from "../contextos/AuthContext";

import toast from "react-hot-toast";

import obtenerRecompensaRandom
	from "../funciones/recompensas";

const Contenedor = styled.div`
	min-height: 100vh;

	padding: 2rem;

	display: flex;
	align-items: center;
	justify-content: center;

	background:
		radial-gradient(
			circle at top,
			#1f2937 0%,
			#0b1120 45%,
			#050816 100%
		);

	color: white;
`;

const Card = styled.div`
	width: 100%;
	max-width: 500px;

	background:
		rgba(255,255,255,0.05);

	border:
		1px solid rgba(255,255,255,0.08);

	border-radius: 30px;

	padding: 2rem;

	text-align: center;
`;

const Cofre = styled.div`
	font-size: 8rem;

	margin-bottom: 2rem;

	cursor: pointer;

	transition: 0.3s ease all;

	&:hover {
		transform:
			scale(1.08)
			rotate(-3deg);
	}
`;

const Titulo = styled.h1`
	margin-bottom: 1rem;
`;

const Texto = styled.div`
	color: rgba(255,255,255,0.7);

	line-height: 1.6;
`;

const Reward = styled.div`
	margin-top: 2rem;

	font-size: 1.4rem;
	font-weight: 800;

	color: #facc15;
`;

const Cooldown = styled.div`
	margin-top: 2rem;

	color: #ef4444;

	font-weight: 700;
`;

const Cofres = () => {

	const { usuario } = useAuth();

	const [reward, setReward] =
		useState(null);

	const [cooldown, setCooldown] =
		useState(false);

	useEffect(() => {

		const cargar = async () => {

			if (!usuario) return;

			const ref = doc(
				db,
				"usuarios",
				usuario.uid
			);

			const snap =
				await getDoc(ref);

			if (!snap.exists()) return;

			const data = snap.data();

			const hoy =
				new Date()
					.toDateString();

			if (
				data.lastChest === hoy
			) {

				setCooldown(true);
			}
		};

		cargar();

	}, [usuario]);

	const abrirCofre =
		async () => {

		if (cooldown) return;

		const recompensa =
			obtenerRecompensaRandom();

		setReward(recompensa);

		toast.success(
			recompensa.texto
		);

		const ref = doc(
			db,
			"usuarios",
			usuario.uid
		);

		await setDoc(
			ref,
			{
				lastChest:
					new Date().toDateString()
			},
			{
				merge: true
			}
		);

		setCooldown(true);
	};

	return (

		<Contenedor>

			<Card>

				<Titulo>
					🎁 Cofre diario
				</Titulo>

				<Texto>
					Abre tu recompensa diaria
					y gana ventajas para subir
					de rango más rápido.
				</Texto>

				<Cofre
					onClick={abrirCofre}
				>

					🎁

				</Cofre>

				{reward && (

					<Reward>

						{reward.texto}

					</Reward>
				)}

				{cooldown && (

					<Cooldown>

						⏳ Ya reclamaste
						el cofre de hoy

					</Cooldown>
				)}

			</Card>

		</Contenedor>
	);
};

export default Cofres;